/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */
import find from 'lodash/find'
import forEach from 'lodash/forEach'
import isEmpty from 'lodash/isEmpty'
import each from 'lodash/each'

export default {
  getConfigurableOptMap: (state) => {
    let map = {}
    let options = state.current.configurable_options
    if (options) {
      forEach(confOpt => {
        map[confOpt.attribute_id] = confOpt.attribute_code
      })
    }
    return map
  },
  sizeTranslateMap (state) {
    let mapSizeCountry = {}
    if (state.current.configurable_options) {
      let sizeConfigurations = find(state.current.configurable_options, { 'attribute_code': 'size' })
      if (sizeConfigurations) {
        forEach(sizeConfigurations.values, sizeValue => {
          mapSizeCountry[sizeValue.value_index] = {}
          // map translations
          forEach(sizeValue.translations, sizeTranslate => {
            mapSizeCountry[sizeValue.value_index][sizeTranslate.zone] = sizeTranslate.label
          })
        })
      }
    }
    return mapSizeCountry
  },
  getVariantByFilter: (state, getters) => (skip, filterActive) => {
    // let exitForm = false
    let options = []
    let skipDuplicate = {}
    let filter = isEmpty(filterActive) ? state.filterActive : filterActive
    let confMap = getters.getConfigurableOptMap
    let variants = state.current.variants
    let exitFor
    let attributeMap
    if (variants) {
      for (let i in variants) {
        exitFor = false
        attributeMap = {}
        if (variants[i].attributes.length) {
          each(variants[i].attributes, item => {
            attributeMap[item.code] = item
          })
          if (!skipDuplicate[attributeMap[skip]]) {
            for (let key in filter) {
              if (confMap[key] !== skip) {
                if (attributeMap[confMap[key]].value_index !== filter[key]) {
                  exitFor = true
                  break
                }
              }
            }
            if (!exitFor) {
              options.push({
                label: attributeMap[skip].label,
                value: attributeMap[skip].value_index,
                is_pre_order: variants[i].product.is_preorder,
                // quantity: variants[i].product.only_x_left_in_stock, // not use animore
                quantity: variants[i].product.quantity,
                in_stock: variants[i].product.stock_status === 'IN_STOCK'
              })
              skipDuplicate[attributeMap[skip].value_index] = true
            }
          }
        }
      }
    }
    return options
  }
}
